import { useMemo } from 'react';

// Using standard HTML5 Audio
// Note: Paths updated to match repo assets (double extension .mp3.ogg)
export const useGameSounds = () => {
  
  // Memoize the audio objects so they aren't recreated on every render
  const sounds = useMemo(() => ({
    success: new Audio('/sounds/pop.mp3.ogg'),
    error: new Audio('/sounds/crunch.mp3.ogg'),
    extinguish: new Audio('/sounds/hiss.mp3.ogg'),
    fire: new Audio('/sounds/fire_whoosh.mp3.ogg'),
    win: new Audio('/sounds/fanfare.mp3.ogg')
  }), []);

  // Helper to play a sound safely
  const playSound = (type) => {
    const audio = sounds[type];
    if (audio) {
      audio.currentTime = 0; // Reset to start (allows rapid fire)
      audio.volume = 0.5; // Keep it subtle
      
      // Browser autoplay policy handling
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          // Silent catch to prevent console spam if user hasn't interacted yet
          // console.warn("Audio playback blocked:", error);
        });
      }
    }
  };

  return {
    playSuccess: () => playSound('success'),
    playError: () => playSound('error'),
    playExtinguish: () => playSound('extinguish'),
    playFire: () => playSound('fire'), // For hitting a streak
    playWin: () => playSound('win')
  };
};